import React from "react";
import HistoricalUnitPricesPage from "./HistoricalUnitPricesPage";

const OnePathHistoricalUnitPrices = () => (
  <HistoricalUnitPricesPage
    pageTitle="Historical Unit Prices"
    reportName="OnePathUnitPrice"
    fundsLocalFilePath={process.env.REACT_APP_OA_FUNDS_LOCAL_DATA}
    historicalLocalFilePath={process.env.REACT_APP_OA_HISTORICAL_LOCAL_DATA}
  />
);

export default OnePathHistoricalUnitPrices;